import { lazy, Suspense } from "react";
import Loader from "../custom/loader/main";

const Main = lazy( () => import("../components/generateStudentScore/main"));

const GenerateStudentScore = () => {
  return (
    <Suspense fallback={<Loader/>}>
      <Main/>
    </Suspense>
  );
};

export default GenerateStudentScore;